import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import AsyncSelect from "react-select/lib/Async";
import DatePicker from "react-datepicker";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import Modal from "react-responsive-modal";
import { PadresPTApi } from "../api/PadresPTApi";
import { Controller, useForm } from "react-hook-form";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import moment from "moment";
import { useDebouncedAsyncSelect } from "../../../../../../Utils/Hooks/useDebounce";

export const FormPadresPT = (props) => {
    const { opened, onClose, onSuccess, padrePTSeleccionado } = props;

    // formulario
    const {
        control: formControl,
        register: formRegister,
        formState: { errors },
        getValues: formGetValues,
        trigger: validateForm,
        reset: formReset,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            nombre: padrePTSeleccionado ? padrePTSeleccionado.nombre : "",
        },
    });

    useEffect(() => {
        if (padrePTSeleccionado) {
            formReset({
                nombre: padrePTSeleccionado.nombre,
            });
        } else {
            formReset({ nombre: "" });
        }
    }, [padrePTSeleccionado, formReset]);

    const {
        crearPadreProductoTerminado,
        actualizarPadreProductoTerminado,
        getAcopios,
        cargando,
    } = PadresPTApi();

    const CrearPadrePT = async (data) => {
        try {
            await crearPadreProductoTerminado(data);

            NotificationManager.success(
                "Padre de producto terminado creado correctamente",
                "Éxito",
                3000,
            );

            formReset({ nombre: "" });
            onSuccess();
            onClose();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear padre de producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EditarPadrePT = async (data) => {
        try {
            await actualizarPadreProductoTerminado(
                padrePTSeleccionado.id,
                data,
            );

            NotificationManager.success(
                "Padre de producto terminado actualizado correctamente",
                "Éxito",
                3000,
            );

            formReset({ nombre: "" });
            onSuccess();
            onClose();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar padre de producto terminado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const SubmitForm = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const data = {
            nombre: formGetValues("nombre"),
        };

        if (padrePTSeleccionado) {
            EditarPadrePT(data);
        } else {
            CrearPadrePT(data);
        }
    };

    const loadAcopios = useDebouncedAsyncSelect(function (search) {
        return getAcopios({ search: search });
    });

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
            // limitar ancho con styles
            styles={{
                modal: {
                    maxWidth: "600px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h4 className="text-center mb-3">
                    {padrePTSeleccionado
                        ? "Actualizar padre de producto terminado"
                        : "Nuevo padre de producto terminado"}
                </h4>

                <div className="formulario-fields-column gap-1rem">
                    <div className="formulario-field">
                        <label htmlFor="nombre" className="m-0">
                            Nombre
                        </label>

                        <div className="d-flex align-items-center">
                            <div className="flex-1">
                                <input
                                    type="text"
                                    {...formRegister("nombre", {
                                        required: "Este campo es obligatorio",
                                    })}
                                    placeholder="Nombre"
                                    className="form-control"
                                />
                                {errors.nombre && (
                                    <small className="text-danger">
                                        {errors.nombre.message}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Cancelar
                    </button>
                    <button className="btn btn-primary" onClick={SubmitForm}>
                        {padrePTSeleccionado ? "Actualizar" : "Crear"}
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
